// Declare gTM dataLayer array.
declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

const dataLayerName = 'dataLayer';
const dataLayer = (window[dataLayerName] = window[dataLayerName] || []);

function install(gtmId: string, VERSION: string) {
  dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
    version: VERSION,
  });

  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}&l=${dataLayerName}`;
  script.async = true;

  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode?.insertBefore(script, firstScript);
}

export { install, dataLayer };
